import { actionTypes } from './reducer';

export const advertisementsSetHandler = (dispatch, advertisements, advertisementGroups, campaigns) => {
  dispatch({
    type: actionTypes.ADVERTISEMENTS_SET,
    payload: {
      advertisements,
      advertisementGroups,
      campaigns
    }
  });
};

export const advertisementDeleteHandler = (dispatch, id) => {
  dispatch({
    type: actionTypes.ADVERTISEMENT_DELETE,
    payload: {
      id
    }
  });
};

export const advertisementsSetLoadingHandler = (dispatch) => {
  dispatch({
    type: actionTypes.ADVERTISEMENTS_SET_LOADING,
    payload: {}
  });
};

export const advertisementsResetLoadingHandler = (dispatch) => {
  dispatch({
    type: actionTypes.ADVERTISEMENTS_RESET_LOADING,
    payload: {}
  });
};
